import { createContext } from "react";

export interface Config {
  AUTH_CLIENT_ID: string;
  AUTH_AUTHORITY: string;
  AUTH_AUTHORITY_KNOWNS?: string;
  AUTH_SCOPE: string;
  API_URL: string;
}

const ConfigContext = createContext<Config>(null as any);

export default ConfigContext;
